import React, { useContext, useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { FiHome, FiPhoneCall, FiStar } from "react-icons/fi";
import MyContext from "../../../Uttis/MyContext";
import "./Bottom.scss";

const Bottom = () => {
  const { location,handleCallClick } = useContext(MyContext);
  const [hideFooter, setHideFooter] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 90) setHideFooter(false);
      else setHideFooter(true);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);



  const hiddenRoutes = ["/vxeditor", "/admino"];

  if (
    !hideFooter ||
    location.pathname.match(
      /^\/(html|learning|sql|css|certi-details|student-registration|css-advance|javascript|project|reactjs|vxeditor|express-js|excel|cyber-security|php)\//
    ) ||
    hiddenRoutes.includes(location.pathname)
  ) {
    return null;
  }

  return (
    <div className="bottom-navigation">
      <div className="nav-item" onClick={handleCallClick}>
        <FiPhoneCall />
        <span>Call</span>
      </div>

      <div
        className="nav-item new-badge"
        onClick={() =>
          window.open(
            "https://v-extechsolution.in/course-batch/fullstack-development-internship"
          )
        }
      >
        <FiStar />
        <span>New</span>
      </div>

      <NavLink to="/" className="nav-item" exact>
        <FiHome />
        <span>Home</span>
      </NavLink>
    </div>
  );
};

export default Bottom;
